import { Box, Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { useLocationSearch } from 'src/helpers/hooks/useLocationSearch';

const HOMEPAGE_URL = ROUTES.LEARN_PATH;

const Error404 = ({ clearErrorState }: { clearErrorState?: () => void }) => {
  const history = useNavigate();
  const getUrlWithQueryParams = useLocationSearch();

  const handleBackClick = () => {
    clearErrorState && clearErrorState();
    history(getUrlWithQueryParams(HOMEPAGE_URL));
  };

  return (
    <Grid
      container
      bgcolor="background.default"
      minHeight={{ xs: '90vh' }}
      direction={{ lg: 'row-reverse' }}
      alignItems="center"
      justifyContent="space-between"
      paddingX={5}
      paddingTop={13}
      paddingBottom={{ xs: 13, lg: 5 }}
      gap={{ xs: 3, lg: 0 }}
    >
      <Grid item xs={12} lg={6}>
        <Box
          component="img"
          sx={{
            content: `url(${'/assets/images/Collage.png'})`,
            maxWidth: '100%',
          }}
          alt="Logo"
        />
      </Grid>
      <Grid
        item
        xs={12}
        lg={5}
        container
        gap={4}
        display="flex"
        textAlign={{ xs: 'center', lg: 'left' }}
        flexDirection="column"
        justifyContent="center"
        alignItems={{ xs: 'center', lg: 'flex-start' }}
      >
        <Box
          border="1px solid black"
          borderRadius="30px"
          width="50px"
          textAlign="center"
        >
          <Typography variant="body1">404</Typography>
        </Box>
        <Typography variant="h2" fontFamily="Ivar Display">
          Looks like no one is home
        </Typography>
        <Typography variant="body1">Let's knock on a different door</Typography>
        <Box>
          <Button
            variant="contained"
            onClick={handleBackClick}
            style={{ width: '190px' }}
          >
            Back to Homepage
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Error404;
